import { render, staticRenderFns } from "./CompletedPacking.vue?vue&type=template&id=1b83b6cd&"
import script from "./CompletedPacking.vue?vue&type=script&lang=js&"
export * from "./CompletedPacking.vue?vue&type=script&lang=js&"
import style0 from "./CompletedPacking.vue?vue&type=style&index=0&id=1b83b6cd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports